import { render, staticRenderFns } from "./CompanyHolidayLocation.vue?vue&type=template&id=42d89c76"
import script from "./CompanyHolidayLocation.vue?vue&type=script&lang=js"
export * from "./CompanyHolidayLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports